import { Device } from 'DeviceUtils';
import Theme from 'Theme';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: Theme.primaryMargin,
        backgroundColor: 'black'
    },
    innerContainer: {
        flex: 1,
        // width: Device.isPhone ? '100%' : '50%',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    infoIcon: {
        width: 25,
        height: 25,
        marginBottom: 10
    },
    textContainer: {
        alignItems: 'center',
        // flexDirection: Device.isTablet ? 'row' : 'column',
        marginBottom: Device.isTablet ? 15 : 10
    },
    title: {
        fontFamily: Theme.regularFont,
        fontSize: 25,
        paddingHorizontal: 10
    },
    hr: {
        marginBottom: 20
    },
    description: {
        fontSize: 18,
        textAlign: 'center'
    },
    button: {
        minWidth: 225,
        alignSelf: Device.isTablet ? 'center' : 'stretch',
        marginHorizontal: Theme.BU / 2,
        marginTop: 10 + Theme.BU / 2
    }
});

export default styles;
